import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { Placement, SelectPicker } from '@/components/Elements/SelectPicker/SelectPicker';
import { APP_LANGUAGES } from '@/config/appConstants';

const LanguageSelectorWrap = styled.div``;

export type LanguageSelectorProps = {
  placement?: Placement;
};
export const LanguageSelector = ({ placement }: LanguageSelectorProps) => {
  const { t, i18n } = useTranslation();

  const data = APP_LANGUAGES.map((lang) => {
    return { label: t('Languages.' + lang), value: lang };
  });

  return (
    <LanguageSelectorWrap>
      <div className="language__selector max-w-[115px]">
        <SelectPicker
          data={data}
          placeholder={t('Languages.' + i18n.language)}
          placement={placement}
          searchable={false}
          style={{ width: 224 }}
          onChange={(value: any) => {
            value && void i18n.changeLanguage(value);
          }}
        />
      </div>
    </LanguageSelectorWrap>
  );
};
